import type { ReactNode } from 'react';
import { REMARK_TAG_LABELS, REMARK_TAG_TONES, remarkToneOf, type RemarkTag, type RemarkTone } from '@nest-recruit/shared';
import { Chip, type ChipTone } from '../../../components/Chip';
import styles from './remarks.module.css';

/** A remark's tone in the app's tones (ADR 0035): a good sign, something to check, a no; the rest follow the area. */
export const REMARK_CHIP_TONES: Readonly<Record<RemarkTone, ChipTone>> = {
  good: 'success',
  check: 'attention',
  no: 'danger',
  neutral: 'neutral',
};

export function RemarkTags({ tags }: { readonly tags: readonly RemarkTag[] }): ReactNode {
  if (tags.length === 0) return null;
  return (
    <span className={styles.tags}>
      {tags.map((tag) => (
        <Chip key={tag} tone={REMARK_CHIP_TONES[REMARK_TAG_TONES[tag]]} plain>
          {REMARK_TAG_LABELS[tag]}
        </Chip>
      ))}
    </span>
  );
}

/** The one dot a remark shows in a tight space: its most urgent tag's tone. */
export function RemarkDot({ tags }: { readonly tags: readonly RemarkTag[] }): ReactNode {
  return <span className={styles.dot} data-tone={remarkToneOf(tags)} aria-hidden />;
}
